module.exports = __webpack_public_path__ + "static/img/10baohuhuanjing.5c107c84.gif";